import { fetchClientFieldVisits } from '@services/protocol';
import { setClientFieldVisits, setClientProtocolNotes, setHistoricalVisitsProtocolId, setHistoricalVisitsTrialId } from '@state-mgmt/slices/visitSlice';
import { AppDispatch } from '@state-mgmt/store';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export default function useFetchClientFieldVisits({
  clientId,
  fieldId,
  trialId,
  protocolId
}: {
  clientId: string | null | undefined;
  fieldId: string | null | undefined;
  trialId: string | null | undefined;
  protocolId: string | null | undefined;
}) {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (clientId && fieldId && trialId) {
      fetchClientFieldVisits({ client_id: clientId, field_id: fieldId, trial_id: trialId })
        .then(response => {
          dispatch(setClientFieldVisits(response.visits));
          dispatch(setClientProtocolNotes(response.protocol_notes));
        })
        .catch(err => {
          console.error('An error occurred fetching client field visits', err);
          dispatch(setClientFieldVisits(null));
          dispatch(setClientProtocolNotes(null));
        });
    } else {
      dispatch(setClientFieldVisits(null));
      dispatch(setClientProtocolNotes(null));
    }

    return () => {
      dispatch(setClientFieldVisits(null));
      dispatch(setClientProtocolNotes(null));
    };
  }, [clientId, fieldId, trialId, dispatch]);

  useEffect(() => {
    if (trialId) {
      dispatch(setHistoricalVisitsTrialId(trialId));
    } else {
      dispatch(setHistoricalVisitsTrialId(null));
    }

    if (protocolId) {
      dispatch(setHistoricalVisitsProtocolId(protocolId));
    } else {
      dispatch(setHistoricalVisitsProtocolId(null));
    }
  }, [trialId, protocolId]);
}
